export default __webpack_public_path__ + "static/media/main_photo.0c3cd522.png";